import { domainSummarySchema } from "@redotech/redo-dns-common/schema";
import * as z from "zod";

/** Every domain this team holds. Released ones are already excluded. */
export const listDnsDomains = {
  name: "listDnsDomains" as const,
  input: z.object({}),
  output: z.object({ domains: z.array(domainSummarySchema) }),
};
